"use client";

import { useState } from "react";

import { useTradingSession } from "#/services/kyan/hooks/useTradingSession";
import { useLiquidationWarningThresholds } from "#/store/app/portfolio/settings/liquidationWarningThresholds";
import { useShowLiquidationNotifications } from "#/store/app/portfolio/settings/showLiquidationNotifications";
import { useShowTradeConfirmation } from "#/store/app/portfolio/settings/showTradeConfirmation";
import { useSlippagePercentage } from "#/store/app/portfolio/settings/slippagePercentage";

export const useSettings = () => {
  const { slippagePercentage, setSlippagePercentage, slippageFactor } =
    useSlippagePercentage();
  const [settings, setSettings] = useState({
    order: false,
    rfq: true,
    status: true,
    email: "",
  });
  const {
    isTradingSessionEnabled,
    isLoading: isLoadingTradingSession,
    isCreatingSession,
    isDeletingSession,
    createSession,
    deleteSession,
    isOneClickTradingDisabled,
  } = useTradingSession();
  const { showTradeConfirmation, setShowTradeConfirmation } =
    useShowTradeConfirmation();
  const { liquidationWarningThresholds, setLiquidationWarningThresholds } =
    useLiquidationWarningThresholds();
  const { showLiquidationNotifications, setShowLiquidationNotifications } =
    useShowLiquidationNotifications();

  const handleChange =
    (key: string) => (value: boolean | number | number[]) => {
      setSettings((previous) => ({ ...previous, [key]: value }));
    };

  const handleAddEmail = () => {
    // TODO: Add modal
  };

  return {
    settings,
    isOneClickTradingDisabled:
      isLoadingTradingSession ||
      isCreatingSession ||
      isDeletingSession ||
      isOneClickTradingDisabled,
    handleChange,
    handleAddEmail,
    createSession,
    deleteSession,
    slippagePercentage,
    slippageFactor,
    setSlippagePercentage,
    isTradingSessionEnabled,
    showTradeConfirmation,
    setShowTradeConfirmation,
    liquidationWarningThresholds,
    setLiquidationWarningThresholds,
    showLiquidationNotifications,
    setShowLiquidationNotifications,
  };
};
